import React, { useState } from "react";

export default function Gallery({ artworks, setOpenArtwork }) {
  const [selectedCategory, setSelectedCategory] = useState("Toutes");
  const [selectedArtist, setSelectedArtist] = useState("Tous");

  // Extraction dynamique des catégories uniques
  const categories = ["Toutes", ...new Set(artworks.map((art) => art.category))];

  // Extraction dynamique des artistes uniques
  const artists = ["Tous", ...new Set(artworks.map((art) => art.artist))];

  // Filtrage des œuvres
  const filteredArtworks = artworks.filter(
    (art) =>
      (selectedCategory === "Toutes" || art.category === selectedCategory) &&
      (selectedArtist === "Tous" || art.artist === selectedArtist)
  );

  return (
    <div className="gallery-container">
      {/* Filtres intégrés dans la galerie */}
      <div className="gallery-filters">
        {/* Sélecteur de catégories dynamique */}
        <select onChange={(e) => setSelectedCategory(e.target.value)} className="gallery-select">
          {categories.map((category) => (
            <option key={category} value={category}>{category}</option>
          ))}
        </select>

        {/* Sélecteur d'artistes dynamique */}
        <select onChange={(e) => setSelectedArtist(e.target.value)} className="gallery-select">
          {artists.map((artist) => (
            <option key={artist} value={artist}>{artist}</option>
          ))}
        </select>
      </div>

      {/* Affichage des œuvres filtrées */}
      <div className="gallery-grid">
        {filteredArtworks.map((art) => (
          <div key={art.id} onClick={() => setOpenArtwork(art)} className="gallery-item">
            <img src={art.image} alt={art.title} className="gallery-image" />
            <p className="gallery-title">{art.title} - {art.artist}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
